export default __webpack_public_path__ + "static/media/VehicleLock_Green.291ccf8c.png";